'use client'

import { TextInput, type TextInputProps } from '@mantine/core'
import { FieldValues, Path, UseFormRegister } from 'react-hook-form'

type FormTextFieldProps<T extends FieldValues> = {
    name: Path<T>
    register: UseFormRegister<T>
    label?: string
    error?: string
    description?: string
    required?: boolean
} & Omit<TextInputProps, 'label' | 'description' | 'error' | 'name'>

export default function FormTextField<T extends FieldValues>({
    name,
    register,
    label,
    error,
    description,
    required,
    size = 'lg',
    'aria-label': ariaLabel,
    ...rest
}: FormTextFieldProps<T>) {
    const accessibleName = ariaLabel ?? label

    return (
        <TextInput
            label={label}
            description={description}
            withAsterisk={label ? required : false}
            size={size}
            error={error}
            aria-label={label ? undefined : accessibleName}
            aria-required={required || undefined}
            {...register(name)}
            {...rest}
        />
    )
}
